import { render } from "./CardProfileForm.vue?vue&type=template&id=1ff58aa7"
import script from "./CardProfileForm.vue?vue&type=script&lang=js"
export * from "./CardProfileForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__